interface IMaskProps {
  isActiveMenu: boolean;
}

const Mask = ({ isActiveMenu }: IMaskProps) => {
  return (
    <div
      tabIndex={-1}
      className={`absolute left-0 top-0 h-screen w-screen z-20 transition-all duration-300 ease-in-out ${
        isActiveMenu
          ? "flex opacity-100 translate-x-0"
          : "flex opacity-0 -translate-x-full visibility-hidden pointer-events-none"
      } bg-transparent-load`}
    />
  );
};
export default Mask;
